module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8bod9"))).then(() => parcelRequire('fhi35'));